export default __webpack_public_path__ + "media/images/elements/fitbit-watch-c0a531d6b3f4a0b6c3d3a720191f4588.png";